import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";

import type { ITiersConfig, ITrafficTitles } from "./trafficDistributionTypes";
import { ETrafficDistributionTypes } from "./trafficDistributionTypes";

const { blue, sky } = colorsPalettes;

export const searchTiersConfig: ITiersConfig[] = [
    {
        get name() {
            return translate("website.analysis.seo.overview.traffic.distribution.search.organic.title");
        },
        color: blue[400],
        visible: true,
        id: "Organic",
    },
    {
        get name() {
            return translate("website.analysis.seo.overview.traffic.distribution.search.paid.title");
        },
        color: sky[300],
        visible: true,
        id: "Paid",
    },
];
export const brandedTiersConfig: ITiersConfig[] = [
    {
        get name() {
            return translate("website.analysis.seo.overview.traffic.distribution.branded.branded.title");
        },
        color: blue[400],
        visible: true,
        id: "Branded",
    },
    {
        get name() {
            return translate("website.analysis.seo.overview.traffic.distribution.branded.nonBranded.title");
        },
        color: sky[300],
        visible: true,
        id: "NonBranded",
    },
];

export const titles: ITrafficTitles = {
    [ETrafficDistributionTypes.SEARCH]: {
        title: "website.analysis.seo.overview.traffic.distribution.search.title",
        tooltip: "website.analysis.seo.overview.traffic.distribution.search.tooltip",
    },
    [ETrafficDistributionTypes.BRANDED]: {
        title: "website.analysis.seo.overview.traffic.distribution.branded.title",
        tooltip: "website.analysis.seo.overview.traffic.distribution.branded.tooltip",
    },
};
